<template>
  <el-row>
    <el-col :span="24">
      <el-card class="box-card">
        <div slot="header" class="clearfix flex justify-between">
          <span>系统配置</span>
          <el-button
            type="primary"
            size="small"
            style="float: right;"
            @click="openEditSystemInfoInfoModel"
          >
            修改
          </el-button>
        </div>
        <div class="card-body">
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">标题名称：</label>
                <span>{{ systemInfoManageInfo.systemTitle }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">副标题：</label>
                <span>{{ systemInfoManageInfo.subSystemTitle }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">简写名称：</label>
                <span>{{ systemInfoManageInfo.systemSimpleTitle }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">公司名称：</label>
                <span>{{ systemInfoManageInfo.companyName }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">logo地址：</label>
                <span>{{ systemInfoManageInfo.logoUrl }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">静态url：</label>
                <span>{{ systemInfoManageInfo.imgUrl }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">默认小区编号：</label>
                <span>{{ systemInfoManageInfo.defaultCommunityId }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">业主标题：</label>
                <span>{{ systemInfoManageInfo.ownerTitle }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">物业手机标题：</label>
                <span>{{ systemInfoManageInfo.propertyTitle }}</span>
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">qq地图key：</label>
                <span>{{ systemInfoManageInfo.qqMapKey }}</span>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="form-item">
                <label class="form-label">商城地址：</label>
                <span>{{ systemInfoManageInfo.mallUrl }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-card>
      <edit-system-info ref="editSystemInfo"></edit-system-info>
    </el-col>
  </el-row>
</template>

<script>
import { getSystemInfoList } from '@/api/frame/systemInfoApi'
import EditSystemInfo from '@/components/frame/editSystemInfo/editSystemInfo.vue'

export default {
  name: 'SystemInfoManage',
  components: {
    EditSystemInfo
  },
  data() {
    return {
      systemInfoManageInfo: {
        systemId: '',
        systemTitle: '',
        subSystemTitle: '',
        companyName: '',
        logoUrl: '',
        imgUrl: '',
        defaultCommunityId: '',
        ownerTitle: '',
        propertyTitle: '',
        qqMapKey: '',
        mallUrl: '',
        systemSimpleTitle: ''
      }
    }
  },
  created() {
    this.listSystemInfos()
  },
  methods: {
    openEditSystemInfoInfoModel() {
      this.$refs.editSystemInfo.open(this.systemInfoManageInfo)
    },
    listSystemInfos() {
      const params = {
        page: 1,
        row: 1
      }
      getSystemInfoList(params)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.systemInfoManageInfo = res.data[0]
          }
        })
        .catch(error => {
          console.error('请求失败处理', error)
        })
    }
  }
}
</script>

<style scoped>
.form-item {
  margin-bottom: 20px;
}
.form-label {
  font-weight: bold;
  margin-right: 10px;
}
.card-body {
  padding: 20px;
}
</style>